const Roles = {
    ADMIN: '#123',
    USER: '@321',
} as const;

export default Roles;
